import Swiper from 'swiper/bundle'

class Slider {
  constructor () {
    this.init()
  }

  init () {
    // Testimonials slider
    const sliderTestimonials = new Swiper('.c-testimonials--js', { // eslint-disable-line
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-testimonials-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-testimonials-button-next',
        prevEl: '.swiper-testimonials-button-prev'
      },
      breakpoints: {
        1024: {
          loop: true,
          slidesPerView: 3,
          resizeObserver: true,
          centeredSlides: true,
          spaceBetween: 60
        }
      }
    })

    // Featured Icons slider
    const sliderFeaturedIcons = new Swiper('.c-featuredIcons', { // eslint-disable-line
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-featuredIcons-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-featuredIcons-button-next',
        prevEl: '.swiper-featuredIcons-button-prev'
      },
      breakpoints: {
        1024: {
          loop: false,
          slidesPerView: 3,
          pagination: false,
          navigation: false,
          spaceBetween: 0
        }
      }
    })

    // Posts slider
    const sliderPosts = new Swiper('.c-postsSlider__wrapper', { // eslint-disable-line
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        clickable: true
      },
      breakpoints: {
        1024: {
          loop: true,
          slidesPerView: 3,
          resizeObserver: true
        }
      }
    })

    // Featured Centers slider
    const featuredCenters = new Swiper('.c-featuredCenters', { // eslint-disable-line
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        clickable: true
      },
      breakpoints: {
        1024: {
          loop: false,
          slidesPerView: 3,
          resizeObserver: true,
          centerInsufficientSlides: true
        }
      }
    })

    // Featured Logos Sliders
    const sliderFeaturedLogos = new Swiper('.c-featuredLogosSlider__containerBck', { // eslint-disable-line
      direction: 'horizontal',
      watchOverflow: true,
      loop: false,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-featuredLogosSlider-button-next',
        prevEl: '.swiper-featuredLogosSlider-button-prev'
      },
      breakpoints: {
        1024: {
          slidesPerView: 3
        }
      },
      on: {
        afterInit: function (swiper) {
          if (swiper.slides.length === 1) {
            swiper.navigation.destroy()
            swiper.navigation.nextEl.remove()
            swiper.navigation.prevEl.remove()
          }
        }
      }
    })

    // Hero Slider
    const heroslider = new Swiper(".homeswiper", { // eslint-disable-line
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      }
    })

    // Initialize Swiper Slider with thumbnails
    const thumbSwiper = new Swiper('.mySwiper_distrib_thumb', { // eslint-disable-line
      spaceBetween: 10,
      slidesPerView: 2,
      freeMode: true,
      speed: 1000,
      watchSlidesProgress: true,
      breakpoints: {
        1280: {
          slidesPerView: 5
        },
        768: {
          slidesPerView: 3
        }
      }
    })

    const mainSwiper = new Swiper('.mySwiper_distrib', { // eslint-disable-line
      spaceBetween: 10,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 1000,
      thumbs: {
        swiper: thumbSwiper
      }
    })

    mainSwiper.on('slideChange', function () { // eslint-disable-line
      var currentIndex = mainSwiper.realIndex
      thumbSwiper.slideTo(currentIndex)
    })

    /* Initialize Swiper Sedes Mobile (no work rows, in footer)
    const swiper = new Swiper('.mySwiper_homebl9_mobile', { // eslint-disable-line
      slidesPerView: 1,
      grid: {
        rows: 2
      },
      spaceBetween: 5,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    }) */

    // Metodo Linkia Home Slider
    const sliderHomeBl2 = new Swiper('.c-home_bloque2__containerBck', { // eslint-disable-line
      direction: 'horizontal',
      watchOverflow: true,
      loop: true,
      effect: 'fade',
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-home_bloque2-button-next',
        prevEl: '.swiper-home_bloque2-button-prev'
      },
      breakpoints: {
        1024: {
          slidesPerView: 1
        }
      },
      on: {
        afterInit: function (swiper) {
          if (swiper.slides.length === 1) {
            swiper.navigation.destroy()
            swiper.navigation.nextEl.remove()
            swiper.navigation.prevEl.remove()
          }
        }
      }
    })

    // Sobre Linkia Home Slider
    const sliderHomeBl3 = new Swiper('.c-home_bloque3__containerBck2', { // eslint-disable-line
      direction: 'horizontal',
      watchOverflow: true,
      loop: false,
      slidesPerView: 1,
      spaceBetween: 5,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-home_bloque3-button-next',
        prevEl: '.swiper-home_bloque3-button-prev'
      },
      breakpoints: {
        1280: {
          slidesPerView: 3
        },
        1440: {
          slidesPerView: 3
        },
        1920: {
          slidesPerView: 4
        }
      },
      on: {
        afterInit: function (swiper) {
          if (swiper.slides.length === 1) {
            swiper.navigation.destroy()
            swiper.navigation.nextEl.remove()
            swiper.navigation.prevEl.remove()
          }
        }
      }
    })

    // Insercción Laboral Home Slider
    const sliderHomeBl8 = new Swiper('.c-home_bloque4__containerBck4', { // eslint-disable-line
      direction: 'horizontal',
      watchOverflow: true,
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      loop: true,
      breakpoints: {
        1280: {
          slidesPerView: 3
        },
        1440: {
          slidesPerView: 4
        },
        1920: {
          slidesPerView: 5
        }
      }
    })

    // Testimonios Home Slider
    const sliderHomeBl5 = new Swiper('.c-home_bloque5__containerBck5', { // eslint-disable-line
      direction: 'horizontal',
      watchOverflow: true,
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        1024: {
          slidesPerView: 3
        },
        1080: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 4
        },
        1440: {
          slidesPerView: 4
        },
        1920: {
          slidesPerView: 4
        }
      }
    })

    // Sedes examenes Home Slider
    const sliderHomeBl9 = new Swiper('.c-home_bloque9__containerBck9', { // eslint-disable-line
      slidesPerView: 1,
      grid: {
        rows: 2
      },
      spaceBetween: 5,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-home_bloque9-button-next',
        prevEl: '.swiper-home_bloque9-button-prev'
      },
      breakpoints: {
        1280: {
          slidesPerView: 3,
          grid: {
            rows: 2
          }
        },
        1440: {
          slidesPerView: 3,
          grid: {
            rows: 2
          }
        },
        1920: {
          slidesPerView: 4,
          grid: {
            rows: 2
          }
        }
      },
      on: {
        afterInit: function (swiper) {
          if (swiper.slides.length === 1) {
            swiper.navigation.destroy()
            swiper.navigation.nextEl.remove()
            swiper.navigation.prevEl.remove()
          }
        }
      }
    })

    // Grados Especificos Bloque 7 Desktop
    const sliderGEBl7 = new Swiper('.mySwiper_bl7_desktop', { // eslint-disable-line
      effect: 'overflow',
      grabCursor: true,
      centeredSlides: true,
      initialSlide: 0,
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      coverflowEffect: {
        rotate: 0,
        stretch: -40,
        depth: 0,
        modifier: 1,
        slideShadows: false
      },
      breakpoints: {
        1024: {
          slidesPerView: 2
        },
        1080: {
          slidesPerView: 2
        },
        1200: {
          slidesPerView: 2
        },
        1280: {
          slidesPerView: 2
        },
        1440: {
          slidesPerView: 2
        },
        1920: {
          slidesPerView: 2
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })

    // Grados Especificos Bloque 7 Mobile
    const sliderGEBl7Mob = new Swiper('.mySwiper_bl7_mobile', { // eslint-disable-line
      slidesPerView: 1,
      spaceBetween: 5,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })

    // Selector de Cursos Mobile
    const sliderCSelectMob = new Swiper('.mySwiper_c-select_mobile', { // eslint-disable-line
      slidesPerView: 1,
      spaceBetween: 5,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })

    // Bloque Otras Formaciones
    const sliderOFormation = new Swiper('.mySwiper_c-other-formation', { // eslint-disable-line
      slidesPerView: 1,
      spaceBetween: 5,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })

    // Cursos Bloque Alumnos
    const sliderCurBl10 = new Swiper(".mySwiper_bl8_alum", { // eslint-disable-line
      slidesPerView: 4,
      pagination: {
        el: '.swiper-testimonials-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-c-grado_esp_bloque10-button-next',
        prevEl: '.swiper-c-grado_esp_bloque10-button-prev'
      }
    })

    // Cards - Grid Oferta Formativa
    const sliderGridOffer = new Swiper('.mySwiper', { // eslint-disable-line
      effect: 'overflow',
      grabCursor: true,
      centeredSlides: true,
      initialSlide: 0,
      slidesPerView: 'auto',
      spaceBetween: 30,
      coverflowEffect: {
        rotate: 0,
        stretch: -40,
        depth: 0,
        modifier: 1,
        slideShadows: false
      },
      breakpoints: {
        810: {
          initialSlide: 1
        }
      },
      pagination: {
        el: '.swiper-pagination'
      }
    })

    // Cursos Bloque 2
    const sliderCurBl2 = new Swiper('.mySwiper_bl2', { // eslint-disable-line
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      }
    })

    // Distribuidora Bloque 8
    const sliderDistribBl8 = new Swiper('.mySwiper_bl8', { // eslint-disable-line
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      loop: true,
      breakpoints: {
        1024: {
          slidesPerView: 4
        },
        1080: {
          slidesPerView: 4
        },
        1200: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 3
        },
        1440: {
          slidesPerView: 3
        },
        1920: {
          slidesPerView: 3
        }
      }
    })

    // Texts Slider
    const sliderTexts = new Swiper('.c-textsSlider__container', { // eslint-disable-line
      direction: 'horizontal',
      watchOverflow: true,
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-textsSlider-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-textsSlider-button-next',
        prevEl: '.swiper-textsSlider-button-prev'
      }
    })
  }

  reload () {
    this.init()
  }
}

export default Slider
